/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { newFrom3DCart } from '~/actions/orderNew';
import LocationPicker from '~/components/LocationPicker';
import { Button } from 'react-toolbox/lib/button';
import Title from '~/components/Title';

// import style from './style.scss';

class Import3DCartPage extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      reference: '',
      locationId: null,
    };
  }

  getOrder() {
    newFrom3DCart(
      this.props.dispatch,
      this.context.apiClient,
      this.state.reference,
      this.state.locationId
    )
      .then(res => this.context.dialogPush('order', { id: res.data.order.id }));
  }

  navigate(url) {
    this.context.router.history.push(url);
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <form onSubmit={e => { e.preventDefault(); this.getOrder(); }}>
          <Title>Import order from 3d cart</Title>
          <div style={{ margin: '10px 0' }}>
            Enter the 3D-cart reference number
            <div>
              WH-<input
                required
                value={this.state.reference}
                onChange={e => this.setState({ reference: e.target.value })}
                placeholder="XXXXXX"
                style={{ fontSize: '14px', padding: '5px' }}
              />
            </div>
          </div>
          <div style={{ margin: '10px 0' }}>
            Where should imported containers be put?
            <div>
              <LocationPicker
                required
                value={this.state.locationId}
                onChange={locationId => this.setState({ locationId })}
              />
            </div>
          </div>
          <Button type="submit" label="Import" primary raised icon="archive" />
        </form>
      </div>
    );
  }
}

export default connect()(Import3DCartPage);



// WEBPACK FOOTER //
// ./app/pages/Import3DCart/index.js